export function objectsAreEqual(a, b, debug = false) {
    if (a === b)
        return true;
    if (typeof a !== `object` || typeof b !== `object`) {
        if (debug) {
            console.log(`typeof is not equal`);
            console.log(`a:`, a);
            console.log(`b:`, b);
        }
        return false;
    }
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) {
        if (debug) {
            console.log(`keys length is not equal`);
            console.log(`a:`, keysA);
            console.log(`b:`, keysB);
        }
        return false;
    }
    for (const key of keysA) {
        if (!keysB.includes(key)) {
            if (debug) {
                console.log(`keys are not equal`);
                console.log(`a key:`, key);
                console.log(`b keys:`, keysB);
            }
            return false;
        }
        if (typeof a[key] === `object` && typeof b[key] === `object`) {
            if (!objectsAreEqual(a[key], b[key])) {
                return false;
            }
        }
        else {
            if (a[key] !== b[key] &&
                !(a[key] === undefined && b[key] === null) && // treating null and undefined as equal
                !(a[key] === null && b[key] === undefined)) {
                if (debug) {
                    console.log(`values are not equal`);
                    console.log(`a value:`, a[key], `a key:`, key);
                    console.log(`b value:`, b[key], `b key:`, key);
                }
                return false;
            }
        }
    }
    return true;
}
/** Avoids rendering any NaN or undefineds etc */
export function displayPhoneNumber(partA, partB) {
    const hasNumber = !!partA || !!partB;
    if (!hasNumber) {
        return null;
    }
    return `${partA || ``}${(partA && partB) ? ` ` : ``}${partB || ``}`;
}
export function convertStringToBoolean(str) {
    if (str === `true`)
        return true;
    if (str === `false`)
        return false;
    return undefined;
}
//# sourceMappingURL=genericUtils.js.map